import React from "react";
import {usePreviewContext} from "../../context/PreviewContext";

interface Props {
    text: string;
    children?: JSX.Element;
}

function CCOComment(props: Props) {
    const isPreview = usePreviewContext().isPreview;

    const renderChildren = () => {
        if (props.children) {
            return props.children;
        } else {
            return null;
        }
    }

    return isPreview ? <>
        <span dangerouslySetInnerHTML={{ __html: `<!-- ${props.text} -->` }}></span>
        {renderChildren()}
        </> : renderChildren();
}


export default CCOComment